import type { StyleSystemProps } from '@withjoy/joykit';
import { Box, SpacingStack, styled } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

// our Mobile (simple 'flex') & Desktop (complex 'grid') stylings are not display-compatible

export const Wrapper = styled(Box)<{ isMobile?: boolean }>`
  ${props => (props.isMobile ? 'display: flex;' : '')}

  justify-content: center;
  align-items: right;

  input,
  select {
    font-size: 100%;
  }
`;

export const Grid = styled(Box)<{ isMobile?: boolean }>`
  column-gap: 48px;
  ${props => (props.isMobile ? '' : 'grid-template-rows: auto;')}
  ${props =>
    props.isMobile
      ? ''
      : `
  grid-template-areas:
    'header'
    'body'
  `}
`;

export const StyledHeader = styled(Box)<{ isMobile?: boolean }>`
  /* display: flex; // seems un-needed */
  ${props => (props.isMobile ? 'justify-content: flex-start;' : '')}
  ${props => (props.isMobile ? 'flex-direction: column;' : '')}
  ${props => (props.isMobile ? '' : 'grid-area: header;')}
`;

export const StyledLeftColumn = styled(SpacingStack)``;

export const StyledRightColumn = styled(Box)<{ isMobile?: boolean }>`
  /* display: flex; // seems un-needed */
  ${props => (props.isMobile ? 'align-items: flex-start;' : '')}
  ${props => (props.isMobile ? 'flex-direction: column;' : '')}

  form {
    width: 100%;
  }
`;

const STICKY_COLUMN_RULES: StyleSystemProps = {
  position: [null, null, 'sticky'],
  top: [null, null, 70],
  alignSelf: 'flex-start', // skip isMobile
};

const rightColumnStyles: StyleSystemProps = {
  marginTop: [9, 'initial'],
  paddingX: [null, null, 6],
  // width: ['100%', null, pxToRem(400), pxToRem(512)],
  width: {
    _: '100%',
    sm2: pxToRem(360),
    sm3: pxToRem(400),
    md: pxToRem(512),
  },
  maxWidth: ['100%', null],
  ...STICKY_COLUMN_RULES,
};

const leftColumnStyles: StyleSystemProps = {
  ...STICKY_COLUMN_RULES,
};

export const StyledBody = styled(Box)<{ isMobile?: boolean }>`
  ${props => (props.isMobile ? 'display: block;' : '')}
`;

const bodyStyles = ({ isMobile }: { isMobile?: boolean }): StyleSystemProps => ({
  ...(isMobile
    ? {
        flexDirection: ['column', null, 'row'],
      }
    : {
        display: 'grid',
        gridArea: 'body',
        gridTemplateColumns: ['1fr', null, '1fr max-content'],
        gridColumnGap: [null, null, '24px'],
      }),
  marginTop: [8, null, null, 6],
});

export const StyledFooter = styled(Box)`
  /* display: flex; // seems un-needed */
`;

export const styles = {
  body: bodyStyles,
  rightColumn: rightColumnStyles,
  leftColumn: leftColumnStyles,
};
